import React from 'react';
import Text from './Text';

/**
 * EGGS Card Component
 * Container for content with EGGS styling
 */
export default function Card({
  title,
  subtitle,
  children,
  footer,
  variant = 'default',
  noPadding = false,
  className = '',
  ...props
}) {
  const variantClasses = {
    default: 'bg-white border border-gray-200',
    elevated: 'bg-white shadow-lg',
    outlined: 'bg-white border-2 border-eggs-dark',
    filled: 'bg-gray-100 border border-gray-200',
  };

  const cardClasses = [
    'rounded-lg overflow-hidden',
    'transition-all duration-200',
    variantClasses[variant],
    className
  ].join(' ');

  return (
    <div className={cardClasses} {...props}>
      {(title || subtitle) && (
        <div className="px-6 py-4 border-b border-gray-200">
          {title && (
            <Text type="Heading" variant="h4" className="mb-1">
              {title}
            </Text>
          )}
          {subtitle && (
            <Text type="Body" variant="sm" className="text-gray-600">
              {subtitle}
            </Text>
          )}
        </div>
      )}
      <div className={noPadding ? '' : 'px-6 py-4'}>
        {children}
      </div>
      {footer && (
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
          {footer}
        </div>
      )}
    </div>
  );
}
